import { useCookies } from 'react-cookie'
import { useQuery as useQueryDefault } from '@apollo/client'
import { GetCart } from '../../../../apps/checkout/src/client/graphql/queries'

export default (opts?: { skip?: boolean; useQuery?: any }): any => {
  if (opts?.skip) {
    return undefined
  }

  const [cookies] = useCookies()

  const cartId = cookies._sg_cartId

  const useQuery = opts?.useQuery || useQueryDefault

  const { data } = useQuery(GetCart, {
    context: { version: 2 },
    variables: { id: cartId },
    skip: !cartId,
  })

  return data?.cart
}
